import { useEffect, useState } from 'react';
import { channelInfo } from '@op/components/ChannelLabel';
import { channelDivisionMap } from '@op/constants/request';
import { getWeeklyAccount_AccountFilter } from '@op/services';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getAccountListValue } from '@op/pages/CustomizedReports/WeeklyReport/OfficialAccountsPerformance/utils';
import { getAccountValue } from '@op/components/FilterCommon/utils/monitorUtil';

export function useAccountFilterList({ filter, gameInfo }: any) {
  const [accountFilterOptions, setAccountFilterOptions] = useState<any>([]);
  const [defaultSelectAccount, setDefaultSelectAccount] = useState<any>([]);
  const { wrapperCancelRequest, loading: accountFilterLoading } =
    useCancelRequestHook({
      defaultLoading: true,
    });

  useEffect(() => {
    if (!filter) return;

    setAccountFilterOptions([]);
    setDefaultSelectAccount([]);
    const { date_type, start_time, end_time } = filter;

    wrapperCancelRequest(getWeeklyAccount_AccountFilter, {
      ...gameInfo,
      date_type,
      start_time,
      end_time,
    })
      .then((data: any) => {
        const result = categorizeAccountsByChannel(data);

        setAccountFilterOptions(result);
        setDefaultSelectAccount(getAccountListValue(result));
      })
      .catch(console.error);
  }, [filter]);

  return {
    accountFilterOptions,
    defaultSelectAccount,
    accountFilterLoading,
  };
}

export function categorizeAccountsByChannel(accountList: any[]) {
  const categorizedData: Record<string, any[]> = {};

  // 遍历账号列表，按渠道分类
  accountList.forEach(account => {
    const { channel } = account;

    // 查找该channel属于哪个主渠道
    let mainChannel = channel;
    for (const [key, values] of Object.entries(channelDivisionMap)) {
      if (values.includes(channel)) {
        mainChannel = key;
        break;
      }
    }

    // 如果该主渠道还不存在分类对象，则创建一个空数组
    if (!categorizedData[mainChannel]) {
      categorizedData[mainChannel] = [];
    }

    // 将账号添加到对应主渠道的数组中
    categorizedData[mainChannel].push({
      ...account,
      value: getAccountValue({
        ...account,
        account: account.account_display_name,
      }),
      account: account.account_display_name,
    });
  });

  // 转换为数组格式 [{text: key, value: key, children: value}]
  const result = Object.entries(categorizedData).map(([key, value]) => {
    const { name } = channelInfo(key as 'youtube');
    return {
      text: `All ${name}`,
      value: key,
      children: value,
    };
  });

  return result;
}
